<template>

<div id="app" ref="site_top">
    <template v-if="!getLoading">

        <header v-if="!showFlightDeckHeader" class="admin-header"></header>

        <header v-else class="admin-header">
            <div class="brand" @click="toggleFlightDeckNavPane()" v-if="getUser.user_type_code && !getUser.force_password_change">
                <div>
                    <img src="@/assets/img/IconFlightDeckLight.png">
                </div>
                <div>
                    {{ getSiteBrand }} <i :class="['fas', showFlightDeckNavPane ? 'fa-angle-up' : 'fa-angle-down' ]" v-if="getUser.user_type_code"></i>
                    <span v-if="getDLinkCartCount || getMultipleFirearmsSalesCount" class="alert-count"><i class="fa fa-bell"></i> {{ getDLinkCartCount + getMultipleFirearmsSalesCount }}</span>
                </div>
            </div>

            <nav role="main" :class="{ mobileshow: hamburgerOn }" v-if="getUser.user_type_code && !getUser.force_password_change">
                <ul>
                    <li style="border-right: 1px solid #ccc; padding-right: 0.5em; margin-right: 0.5em;">
                        <router-link to="/users/profile">Welcome {{ getUser.user_name }} <i class="fa fa-user"></i></router-link>
                    </li>
                    <li v-if="getUser.clocked_in" style="border-right: 1px solid #ccc; padding-right: 0.5em; margin-right: 0.5em;">
                        <i class="fas fa-clock" title="You are clocked in" />
                    </li>
                    <li><router-link :to='getLoginRoute + "?logout=true"'>Log Out</router-link></li>
                </ul>
            </nav>

            <div class="nav-hamburger" @click="hamburgerOn = !hamburgerOn">
                <i class="fas fa-bars"></i>
            </div>

            <transition name="dropdown">
                <div class="flight-deck-nav-pane" v-if="showFlightDeckNavPane">

                    <div class="column-common">
                        <template v-for="(menuItem, index) in getFlightDeckMetaMenu" v-if="Object.keys(getFlightDeckMetaMenu).length > 0">
                            <div v-if="!menuItem.link_value || menuItem.not_allowed" :class="{ 'not-allowed': menuItem.not_allowed }" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                            <a v-else-if="menuItem.link_type == 'EXTERNAL'" :href="menuItem.link_value" :key="'ext_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</a>
                            <router-link v-else :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'legacy_menu_item_' + menuItem.menu_item_id + index">{{ menuItem.menu_label }}</router-link>
                        </template>
                        <div style="margin: 0.5em 1em 0 0; padding-top: 0.5em; border-top: 1px solid #ccc;">
                            <router-link to="/orders-sales/dlink-offers">DLink Offers<span v-if="getDLinkCartCount" class="alert-count">{{ getDLinkCartCount }}</span></router-link>
                        </div>
                    </div>

                    <div class="flight-deck-nav-pane-columns">

                        <div class="span-all search">
                            <input type="search" v-model="menuItemsSearchTerm" placeholder="Find a program by name">
                            <ul class="filtered-search-menu-items" v-if="filteredSearchMenuItems.length > 0">
                                <li v-for="(menuItem, index) in filteredSearchMenuItems" :key="index">
                                    <span class="not-allowed" v-if="menuItem.not_allowed" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</span>
                                    <a v-else-if="menuItem.link_type == 'EXTERNAL'" :href="menuItem.link_value" :key="'ext_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</a>
                                    <router-link v-else :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'legacy_menu_item_' + menuItem.menu_item_id + index">{{ menuItem.menu_label }}</router-link>
                                </li>
                            </ul>
                        </div>

                        <ul class="columns">
                            <li class="flight-deck-nav-columns" v-for="(subMenu, index) in getFlightDeckMainMenu" :key="'sub-menu-' + index">
                                <div v-if="getAdministratorFlag"></div>
                                <img v-bind:src="require('@/assets/img/Icon' + subMenu.menu_label.split(' ')[0] + '.png')" class="icon" v-else>
                                <div>
                                    <div v-if="subMenu.not_allowed" class="flight-deck-section-title not-allowed">{{ subMenu.menu_label }}</div>
                                    <router-link v-else :to="'/' + subMenu.link_value" class="flight-deck-section-title">{{ subMenu.menu_label }}</router-link>
                                    <template v-for="(menuItem, index) in subMenu.menu_items" v-if="subMenu.menu_items && Object.keys(subMenu.menu_items).length > 0">
                                        <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                                        <a v-else-if="menuItem.link_type == 'EXTERNAL'" :href="menuItem.link_value" :key="'ext_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</a>
                                        <router-link v-else :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'legacy_menu_item_' + menuItem.menu_item_id + index">
                                            {{ menuItem.menu_label }}
                                            <span v-if="menuItem.link_value == '/logbooks/3310' && getMultipleFirearmsSalesCount" class="alert-count">{{ getMultipleFirearmsSalesCount }}</span>
                                        </router-link>
                                    </template>
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>
            </transition>
            <BedrockChatWidget v-if="showBedrockChat" :fd-token="$getCookie('dashboard_token')" :app-version="getAppVersion" :helpcenter-api-url="getHelpcenterApiHost"/>
        </header>

        <div v-if="getNewFeature" class="new-feature-available no-print">{{ getNewFeature }}</div>

        <div class="main" v-if="routeNotAllowed">
            <div class="empty-list">
                <h1>Oops!</h1>
                <p>It looks like you're not allowed to access this page.</p>
                <img src="@/assets/img/sadface.png" style="width: 9em; margin: 2em; opacity: 0.6;">
            </div>
        </div>

    	<router-view v-else />

        <cds-footer v-if="showFlightDeckHeader"></cds-footer>
        <footer v-else class="admin-footer" ></footer>

        <div v-if="showVersionAlert" class="modal">
            <div class="inner">
                <h2>Version Alert</h2>
                <div class="content" style="text-align: center;">
                    <p>You're not using the latest version of Flight Deck.</p>
                    <p>
                        <img src="@/assets/img/sadface.png" style="width: 9em; opacity: 0.6;">
                    </p>
                    <p>Please refresh your browser to update<br>from version <b>{{ getAppVersion }}</b> to the latest version <b>{{ getRegisteredVersion }}</b>.</p>
                </div>
                <div class="controls">
                    <div class="button neutral spaced" @click="forceReload()">Refresh</div>
                </div>
            </div>
        </div>

    </template>
    <loading class="full-page loading-app" v-else></loading>
</div>

</template>

<script>
import '@/styles/_admin.scss'
import BedrockChatWidget from './components/BedrockChatWidget.vue';
export default {
    name: 'App',
    components: {
        BedrockChatWidget
    },
    data() {
        return {
            loadingMenus: false,
			client: {},
			hamburgerOn: false,
			menuItemsSearchTerm: null,
			showFlightDeckNavPane: false,
            hideHeaderFooter: false,
            siteBrand: '',
            accountRequiresUpdate: false,
            alertCount: 2,
            showVersionAlert: false
        }
    },
    created() {
        this.bootstrap()
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('account_update')) {
            this.accountRequiresUpdate = true
        }
    },
    mounted() {
    	if (window.self != window.top) {
            this.hideHeaderFooter = true
        }
    },
    watch: {
        '$route' (newValue, oldValue) {
            // clear any new feature
            this.updateNewFeature()
            // clear any dev note set in a program
            this.updateDevNote();
            // clear any custom route name set in a program
            this.updateCustomRouteName();
            // set the site title
            this.setSiteTitle()
            // close the nav pane
            this.closeNavPane()
        },
        getClientTypeCode(value) {
            // as soon as there is a client_type_code, call global store setSiteBrand
            this.setSiteBrand()
            // and with brand set, now set site title
            this.setSiteTitle()
        },
        getMenuItemPoliciesByLink(value) {
            if (value) {
                if (this.$route.path in this.getMenuItemPoliciesByLink && this.getMenuItemPoliciesByLink[this.$route.path].not_allowed) {
                    this.$router.push('/not-allowed')
                }
            }
        },
        getRegisteredVersion(newVal) {
            if (this.getAppVersion && newVal && this.getAppVersion != newVal) {
                this.showVersionAlert = true
            }
        },
    },
    computed: {
        showFlightDeckHeader() {
            if (this.$route.path.indexOf('customer-4473') != -1) {
                return false
            }
            if (this.$route.query.fd_token) {
                return false
            }
            return true
        },
        flatMenuItems() {
			var flatMenuItems = []
			for (var key in this.getFlightDeckMainMenu) {
				if (this.getFlightDeckMainMenu[key].menu_items) {
					for (var subKey in this.getFlightDeckMainMenu[key].menu_items) {
						this.getFlightDeckMainMenu[key].menu_items[subKey].parent_link_value = this.getFlightDeckMainMenu[key].link_value
						flatMenuItems.push(this.getFlightDeckMainMenu[key].menu_items[subKey])
					}
				}
			}
			return flatMenuItems
		},
		filteredSearchMenuItems() {
            if (!this.menuItemsSearchTerm || this.flatMenuItems.length == 0) {
                return []
            }
            var filteredSearchMenuItems = this.flatMenuItems.filter(item => {
                return item.menu_label.toLowerCase().indexOf(this.menuItemsSearchTerm.toLowerCase()) > -1
            })
            return filteredSearchMenuItems
        },
        routeNotAllowed() {
            let path = this.$route.path
            // Check for any params and/or trailing / in the path and sanitize them
            if (Object.keys(this.$route.params).length > 0) {
                let param = this.$route.params[Object.keys(this.$route.params)[0]]
                path = path.replace('/' + param, '')
            } else if (path.substr(path.length - 1, 1) == '/') {
                path = path.substring(0, path.length - 1)
            }
            if (path in this.getMenuItemPoliciesByLink && this.getMenuItemPoliciesByLink[path].not_allowed) {
                this.$router.push('/not-allowed')
            }
        }, 
        showBedrockChat() {
            return !!(
                this.getUser && this.getUser.user_type_code === 'SUPERADMIN'
            )
        }
    },
    methods: {
        toggleFlightDeckNavPane() {
            if (!this.accountRequiresUpdate && this.getUser.user_type_code && this.getUser.user_type_code != 'AUDITOR') {
                this.showFlightDeckNavPane = !this.showFlightDeckNavPane
            }
        },
        closeNavPane() {
            this.showFlightDeckNavPane = false;
            this.hamburgerOn = false
            this.menuItemsSearchTerm = null
            this.updateOpenDropdown(null)
            window.scrollTo({
                top: this.$refs.site_top.offsetTop,
                left: 0
            })
        },
        setSiteTitle() {
            if (this.$route.name == 'Legacy') {
                document.title = this.getSiteBrand + ' | ' + this.$caplitalizeWords(this.$route.params.iframe_src.replace('maintenance.php','').replace('maintenence.php',''))
            } else {
                document.title = this.getSiteBrand + ' | ' + this.$route.name
            }
        },
        forceReload() {
            window.location.reload(true)
        }
    }
}
</script>

<style lang="css" scoped>
@media print {
  .no-print { display: none !important; }
}
</style>